import React from "react";
import { Tabs, Tab } from "react-bootstrap";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import UserTypes from "components/auth/user-types";

import ListCharges from "components/menu/invoicing/customer/list-charges";
import ListInvoices from "components/menu/invoicing/customer/list-invoices";

class CustomerInvoicingList extends React.PureComponent {
    tabs = {
        charges: "charges",
        invoices: "invoices"
    };

    render() {
        const { auth } = this.props;

        return (
            <div className="dashboard">
                <Tabs
                    id="invoicing-tabs"
                    defaultActiveKey={this.tabs.charges}
                    className="w-100"
                    unmountOnExit={true}
                >
                    <Tab
                        eventKey={this.tabs.charges}
                        title="Charges"
                    >
                        <ListCharges />
                    </Tab>
                    {/* Disable Invoices tab only for accountManager */}
                    {(auth.user.role.includes(UserTypes.accountManager) &&
                        !auth.user.role.includes(UserTypes.admin)) ? null : (
                        <Tab
                            eventKey={this.tabs.invoices}
                            title="Invoices"
                        >
                            <ListInvoices />
                        </Tab>
                    )}
                </Tabs>
            </div>
        );
    }
}

CustomerInvoicingList.propTypes = {
    auth: PropTypes.object.isRequired
};

const mapStateToProps = state => ({
    auth: state.auth,
});

export default connect(
    mapStateToProps,
)(CustomerInvoicingList);
